import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`).pipe(
      catchError(() =>
        lang === 'en_au'
          ? throwError(() => new Error('en_au translation missing'))
          : this.http.get<Translation>('/assets/i18n/en_au.json')
      )
    );
  }
}

@Injectable({ providedIn: 'root' })
export class CustomTranslocoLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    // Relative path from the component to the translation files
    return from(
      import(`./i18n/${lang}.json`) as Promise<Translation>
    );
  }
}
